import React from "react";
import classes from "./FilterItem.module.css";

const FilterItem = ({ children }) => {
  return <div className={classes["filter-item"]}>{children}</div>;
};

export default FilterItem;
